import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'
import L from "leaflet"

export default class extends Controller {
  static values = {
    zoom: Number,
    points: Array,
    center: Object,
    lightnings: Array,
  }

  connect() {
    // Centraliza o mapa no primeiro ponto
    let center = []
    if(this.centerValue) {
      center = [this.centerValue.lat, this.centerValue.lng]
    } else {
      if (this.pointsValue.length === 0) return
      const first = this.pointsValue[0]
      center = [first.lat, first.lng]
    }
    console.log(center)
    this.map = L.map(this.element).setView(center, this.zoomValue)

    console.log(this.centerValue)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(this.map)

    this.pointsValue.forEach((point) => {

      const numberedIcon = L.divIcon({
        html: `
          <div class="relative">
            <img 
              src="https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png"/>
      <span class="absolute top-1 left-1/2 transform -translate-x-1/2 bg-white text-black text-xs font-bold rounded-full px-1">
      ${point.plant_no}
            </span>
          </div>
        `,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [0, -41],
        className: ''
      });

      L.marker([point.lat, point.lng], {icon: numberedIcon})
        .addTo(this.map)
        .bindPopup(point.label || 'Local')
    })
    this.lightningsValue.forEach((point) => {
      const options = {}

      if (point.icon) {
        options.icon = L.icon({
          iconUrl: point.icon,
          iconSize: [32, 32],
          iconAnchor: [16, 32],
          popupAnchor: [0, -32]
        })
      }
      L.marker([point.lat, point.lng], options)
        .addTo(this.map)
        .bindPopup(point.label || 'Local')
        .on('click', () => {
          const url = `/lightning_strikes/${point.id}/details`

          get(url, {
            responseKind: 'turbo-stream'
          })
        })

    })

  }
}


